import '../../../../../../../../../node_modules/@splidejs/splide/dist/css/splide-core.min.css';
import Splide from '@splidejs/splide';

export default class SliderDefaultSetup {
  constructor() {
    const splideElement = document.querySelector('.base-slider__big-slider');

    if (splideElement) {
      this.bigSlider = new Splide('.base-slider__big-slider', {
        pagination: false,
        arrows: false,
        autoWidth: true,
      });

      this.smallSlider = new Splide('.base-slider__small-slider', {
        pagination: false,
        arrows: true,
        autoWidth: true,
        isNavigation: true,
      });

      this.bigSlider.sync(this.smallSlider);

      this.bigSlider.mount();
      this.smallSlider.mount();

      const prevBtn = document.querySelector(
        '.base-slider__small-slider .splide__arrow--prev'
      );
      const nextBtn = document.querySelector(
        '.base-slider__small-slider .splide__arrow--next'
      );

      if (prevBtn && nextBtn) {
        // prevBtn = addEventListener('click', (e) => this.handleClickArrow(e, -1));
        //nextBtn = addEventListener('click', (e) => this.handleClickArrow(e, 1));
      }
    }
  }

  handleClickArrow(e, dir) {
    console.log('trigger', dir);
    if (dir > 0) {
      //next
      this.bigSlider.go(-1);
    } else {
      //prev
      this.bigSlider.go(-1);
    }
  }
}
